var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 116,
    height: 117,
    viewBox: "0 0 116 117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#557ef8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4896f5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(-876.475 -316.622)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 58,
    cy: 58.5,
    rx: 58,
    ry: 58.5,
    transform: "translate(876.475 316.622)",
    fill: "#557ef8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163",
    transform: "translate(900.085 340.476)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M-177.567,2.506l-29.369,50.869a5.013,5.013,0,0,0,4.341,7.519h58.738a5.013,5.013,0,0,0,4.341-7.519L-168.885,2.506A5.013,5.013,0,0,0-177.567,2.506Z",
    transform: "translate(207.615 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(29.303 16.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M-1.619,111.151h0a5.1,5.1,0,0,1,5.065,5.707L1.2,135.6a2.859,2.859,0,0,1-2.839,2.52h0a2.859,2.859,0,0,1-2.839-2.524L-6.685,116.85A5.1,5.1,0,0,1-1.619,111.151Z",
    transform: "translate(6.721 -111.151)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M1.535,317.7a4.132,4.132,0,0,1,0-5.781,3.931,3.931,0,0,1,2.89-1.179,3.933,3.933,0,0,1,2.89,1.179,4.133,4.133,0,0,1,0,5.781,3.932,3.932,0,0,1-2.89,1.179A3.93,3.93,0,0,1,1.535,317.7Z",
    transform: "translate(0.676 -281.629)",
    fill: "url(#linear-gradient)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailicon);
export default __webpack_public_path__ + "static/media/failicon.add86b0f66bda0c5df1b632518b8741e.svg";
export { ForwardRef as ReactComponent };